import { characters } from "@/mocks/lustCaution";

const avatarImages = [
  "https://readdy.ai/api/search-image?query=Abstract%20artistic%20portrait%20texture%20in%20deep%20crimson%20and%20warm%20gold%2C%20soft%20silk%20and%20velvet%20painterly%20surface%2C%20moody%20vintage%20cinematic%20tone%2C%20ornamental%20and%20elegant%2C%20no%20text%2C%20no%20face&width=400&height=400&seq=lust-char-wangjiazhi-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Abstract%20artistic%20texture%20in%20dark%20charcoal%20and%20muted%20gold%2C%20smoke%20and%20velvet%20painterly%20surface%2C%20stern%20vintage%20cinematic%20tone%2C%20restrained%20and%20tense%20mood%2C%20no%20text%2C%20no%20face&width=400&height=400&seq=lust-char-yixiansheng-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Abstract%20artistic%20texture%20in%20soft%20jade%20green%20and%20cream%2C%20paper%20and%20ink%20painterly%20surface%2C%20youthful%20vintage%20cinematic%20tone%2C%20quiet%20and%20earnest%20mood%2C%20no%20text%2C%20no%20face&width=400&height=400&seq=lust-char-kuangyumin-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Abstract%20artistic%20texture%20in%20warm%20amber%20and%20jade%2C%20silk%20brocade%20and%20mahjong%20tile%20painterly%20surface%2C%20refined%20vintage%20cinematic%20tone%2C%20composed%20and%20elegant%20mood%2C%20no%20text%2C%20no%20face&width=400&height=400&seq=lust-char-yitaitai-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Abstract%20artistic%20texture%20in%20faded%20rose%20and%20sand%2C%20cotton%20paper%20painterly%20surface%2C%20nostalgic%20vintage%20cinematic%20tone%2C%20warm%20and%20wistful%20mood%2C%20no%20text%2C%20no%20face&width=400&height=400&seq=lust-char-tongxue-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Abstract%20artistic%20texture%20in%20slate%20grey%20and%20cold%20gold%2C%20metal%20and%20cloth%20painterly%20surface%2C%20austere%20vintage%20cinematic%20tone%2C%20calm%20and%20distant%20mood%2C%20no%20text%2C%20no%20face&width=400&height=400&seq=lust-char-laowu-01&orientation=squarish",
];

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <p className="text-primary-600 font-label text-sm tracking-widest uppercase">Characters</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug">
              关键人物：谁在推动，谁在被动
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              这部电影几乎没有纯粹的旁观者。每个人都在自己的立场里做着艰难的选择，
              而人物之间的拉扯，正是删减最容易影响到的部分。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {characters.map((person, i) => (
              <article
                key={person.name}
                className="flex flex-col rounded-lg bg-background-100 border border-background-200 overflow-hidden"
              >
                <div className="w-full h-40 md:h-44 overflow-hidden">
                  <img
                    src={avatarImages[i]}
                    alt={`${person.name} 的抽象氛围配图`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-2">
                    <span className="w-1.5 h-6 rounded-full bg-primary-500" aria-hidden="true"></span>
                    <h3 className="font-heading text-xl font-semibold text-foreground-950">{person.name}</h3>
                  </div>
                  <p className="mt-1 text-accent-700 font-label text-xs md:text-sm">{person.role}</p>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{person.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}